// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Context from "../../../provider/Context.bs.js";
import * as Atom_Box from "../../atom/Atom_Box.bs.js";
import * as Atom_Cta from "../../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../../atom/Atom_Row.bs.js";
import * as Atom_Cell from "../../atom/Atom_Cell.bs.js";
import * as Atom_Text from "../../atom/Atom_Text.bs.js";
import * as UseOnBlur from "../../../hook/UseOnBlur.bs.js";
import * as Belt_Array from "@rescript/std/lib/es6/belt_Array.js";
import * as Atom_Column from "../../atom/Atom_Column.bs.js";
import * as Atom_Cta_Ds from "../../atom/Atom_Cta_Ds.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_Common from "../../../type/Type_Common.bs.js";
import * as Type_String from "../../../type/Type_String.bs.js";
import * as Atom_Text_Ds from "../../atom/Atom_Text_Ds.bs.js";
import * as Particle_Css from "../../particle/Particle_Css.bs.js";
import * as Type_Sticker from "../../../type/Type_Sticker.bs.js";
import * as UseTrapFocus from "../../../hook/UseTrapFocus.bs.js";
import * as Atom_Image_Ds from "../../atom/Atom_Image_Ds.bs.js";
import * as Particle_zIndex from "../../particle/Particle_zIndex.bs.js";
import * as Atom_Icon_Internal from "../../atom/icon/Atom_Icon_Internal.bs.js";
import * as Particle_Screen_Ds from "../../particle/Particle_Screen_Ds.bs.js";
import * as Particle_Spacer_Ds from "../../particle/Particle_Spacer_Ds.bs.js";
import * as Atom_FavoriteButton from "../../atom/Atom_FavoriteButton.bs.js";
import * as Organism_Teaser_Css from "./Organism_Teaser_Css.bs.js";
import * as Particle_Screen_Css from "../../particle/Particle_Screen_Css.bs.js";
import * as Organism_Teaser_Util from "./Organism_Teaser_Util.bs.js";
import * as Organism_Teaser_Title from "./Organism_Teaser_Title.bs.js";
import * as Particle_Accessibility from "../../particle/Particle_Accessibility.bs.js";
import * as Particle_Background_Ds from "../../particle/Particle_Background_Ds.bs.js";
import * as Organism_Teaser_Subtitle from "./Organism_Teaser_Subtitle.bs.js";
import * as Particle_Screen_Constants from "../../particle/Particle_Screen_Constants.bs.js";
import * as Organism_Teaser_Hover_Play from "./Organism_Teaser_Hover_Play.bs.js";
import * as Organism_Teaser_Css_Identifier from "./Organism_Teaser_Css_Identifier.bs.js";

var modalCloseButtonDisplayOrder = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 1);

var textDisplayOrder = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, 2);

var modalCloseButtonBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.make("S", "Zero", "M", "M", undefined));

var contentBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "M", undefined));

var contentInnerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS");

var genreAndAudioVersionsInnerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");

var genreAndAudioVersionsBlockSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeBottom("XS"));

var innerSpaceRowButtons = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S");

var buttonFavoriteKey = "teaser-hover-fav-button";

var buttonPlayKey = "teaser-hover-play-button";

var buttonTrailerKey = "teaser-hover-trailer-button";

var displayHover = Particle_Screen_Ds.make(undefined, undefined, "flex", undefined, undefined, "none");

function getPictureKind(pictureKind) {
  if (typeof pictureKind === "number") {
    if (pictureKind !== 3) {
      if (pictureKind !== 10) {
        return {
                TAG: /* TeaserHover */3,
                _0: /* Standard */1
              };
      } else {
        return {
                TAG: /* TeaserHover */3,
                _0: /* Portrait */0
              };
      }
    } else {
      return {
              TAG: /* TeaserHover */3,
              _0: /* Big */2
            };
    }
  } else {
    return {
            TAG: /* TeaserHover */3,
            _0: /* Standard */1
          };
  }
}

var iconSize = Particle_Screen_Ds.make(undefined, undefined, "M", undefined, undefined, "XS");

var display = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inlineFlex");

var AudioVersions = {
  iconSize: iconSize,
  display: display
};

var documentAccessibility = Particle_Accessibility.make(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, "Document", undefined, undefined);

var hoverZIndex = Particle_zIndex.Particle_zIndex_Css.toCss({
      TAG: /* Exact */0,
      _0: /* Teaser */16
    });

var zIndexRule = Particle_zIndex.Particle_zIndex_Css.toCss({
      TAG: /* Behind */2,
      _0: /* Teaser */16
    });

var rules = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [
      CssJs.position("fixed"),
      CssJs.top("zero"),
      CssJs.bottom("zero"),
      CssJs.left("zero"),
      CssJs.right("zero"),
      CssJs.opacity(0.8),
      zIndexRule
    ]);

function Organism_Teaser_Hover$Overlay(Props) {
  return React.createElement(Atom_Box.make, {
              background: Particle_Background_Ds.teaserHoverNewOverlay,
              identifier: Organism_Teaser_Css_Identifier.hoverOverlay,
              rules: rules
            });
}

var Overlay = {
  zIndexRule: zIndexRule,
  rules: rules,
  make: Organism_Teaser_Hover$Overlay
};

function Organism_Teaser_Hover(Props) {
  var centerHoverRef = Props.centerHoverRef;
  var children = Props.children;
  var hoverRef = Props.hoverRef;
  var mode = Props.mode;
  var pictureKind = Props.pictureKind;
  var progression = Props.progression;
  var screenReadersLabel = Props.screenReadersLabel;
  var style = Props.style;
  var subtitleId = Props.subtitleId;
  var teaser = Props.teaser;
  var titleId = Props.titleId;
  var title = teaser.title;
  var subtitle = teaser.subtitle;
  var match = teaser.program;
  var programId = match.id;
  var key = teaser.key;
  var description = teaser.description;
  var audioVersions = teaser.audioVersions;
  var match$1 = Context.Config.getState(undefined);
  var match$2 = Context.I18n.getState(undefined);
  var labels = match$2.labels;
  var match$3 = labels.program;
  var match$4 = labels.accessibility;
  var descriptionStyle = style.description;
  var titleStyle = Belt_Option.map(style.title, Atom_Text_Ds.Teaser.Hover.toParent);
  var subtitleStyle = Belt_Option.map(style.subtitle, Atom_Text_Ds.Teaser.Hover.toParent);
  var title$1;
  if (title !== undefined) {
    switch (title.TAG | 0) {
      case /* AccessibilityOnly */1 :
          var title$2 = title._0;
          if (subtitle !== undefined) {
            switch (subtitle.TAG | 0) {
              case /* SubtitleAsTitle */1 :
                  title$1 = undefined;
                  break;
              case /* Normal */0 :
              case /* HoverOnly */2 :
                  title$1 = title$2;
                  break;
              
            }
          } else {
            title$1 = title$2;
          }
          break;
      case /* Displayed */0 :
      case /* HoverOnly */2 :
          title$1 = title._0;
          break;
      
    }
  } else {
    title$1 = undefined;
  }
  var makeDialogAriaLabelledby = function (id) {
    return Particle_Accessibility.AriaLabelledby.makeWithInputArray(Curry._1(Type_String.Teaser.Key.toString, key), [id]);
  };
  var dialogAriaLabelledBy;
  if (title$1 !== undefined) {
    dialogAriaLabelledBy = Belt_Option.map(titleId, makeDialogAriaLabelledby);
  } else if (subtitle !== undefined) {
    switch (subtitle.TAG | 0) {
      case /* SubtitleAsTitle */1 :
          dialogAriaLabelledBy = Belt_Option.map(subtitleId, makeDialogAriaLabelledby);
          break;
      case /* Normal */0 :
      case /* HoverOnly */2 :
          dialogAriaLabelledBy = undefined;
          break;
      
    }
  } else {
    dialogAriaLabelledBy = undefined;
  }
  var match$5 = mode ? [
      React.createElement(Atom_Row.make, {
            blockSpace: modalCloseButtonBlockSpace,
            children: React.createElement(Atom_Cta.Button.make, {
                  identifier: Organism_Teaser_Css_Identifier.hoverCloseButton,
                  label: match$4.close,
                  onClick: mode._0,
                  style: /* TeaserHoverClose */28
                }),
            displayOrder: modalCloseButtonDisplayOrder
          }),
      mode._1,
      {
        TAG: /* Dialog */4,
        _0: dialogAriaLabelledBy
      },
      React.createElement(Organism_Teaser_Hover$Overlay, {})
    ] : [
      null,
      (function (param) {
          
        }),
      undefined,
      null
    ];
  var showTextPart = titleStyle !== undefined || subtitleStyle !== undefined ? true : descriptionStyle !== undefined;
  var panelHoverWrapperMinHeight;
  if (showTextPart) {
    panelHoverWrapperMinHeight = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Organism_Teaser_Css.getHoverWrapperMinHeight(pictureKind));
  } else {
    var param = Atom_Image_Ds.view(Atom_Image_Ds.make(pictureKind));
    panelHoverWrapperMinHeight = Particle_Screen_Ds.map(Organism_Teaser_Util.Hover.getHeightByImageSize, param.size);
  }
  var match$6 = React.useState(function () {
        return Particle_Screen_Constants.emptyRules;
      });
  var setPanelHoverPositionRules = match$6[1];
  React.useEffect((function () {
          var isMount = {
            contents: true
          };
          if (isMount.contents === true) {
            var rules = Particle_Screen_Ds.$$Array.concat(Organism_Teaser_Util.Hover.getPanelHoverPositionRules(centerHoverRef, pictureKind, panelHoverWrapperMinHeight), Organism_Teaser_Css.getPanelHoverWrapperActiveRules(Organism_Teaser_Css.transitionRules));
            Curry._1(setPanelHoverPositionRules, (function (param) {
                    return rules;
                  }));
          }
          return (function (param) {
                    isMount.contents = false;
                  });
        }), [centerHoverRef]);
  UseOnBlur.make(hoverRef, match$5[1]);
  var match$7 = Atom_FavoriteButton.availabilityFromTeaserFavorite(teaser.favoriteStatus);
  var favoriteAvailability = style.favorite === "Available" && match$7 === "Available" ? "Available" : "NotAvailable";
  var playableSticker = Type_Sticker.toArray(teaser.stickers).find(function (sticker) {
        if (typeof sticker !== "object") {
          return false;
        }
        var variant = sticker.NAME;
        if (variant === "Live" || variant === "Playable") {
          return true;
        } else {
          return variant === "Direct";
        }
      });
  var match$8 = teaser.availability;
  var programStatus = playableSticker !== undefined || match$8 === undefined ? /* Playable */0 : /* NotPlayable */1;
  var description$1 = descriptionStyle !== undefined && description !== undefined ? React.createElement(Atom_Text.make, {
          children: description,
          kind: "p",
          style: Curry._1(Atom_Text_Ds.Teaser.Hover.toParent, Caml_option.valFromOption(descriptionStyle))
        }) : null;
  var audioVersions$1 = audioVersions !== undefined && audioVersions.length !== 0 ? Caml_option.some(React.createElement(Atom_Row.make, {
              children: Belt_Array.mapWithIndex(audioVersions, (function (index, param) {
                      var label = param.label;
                      return React.createElement(Atom_Cell.make, {
                                  alignItems: Particle_Screen_Constants.alignItemsCenter,
                                  kind: /* ItemList */4,
                                  children: null,
                                  key: label + String(index)
                                }, React.createElement(Atom_Icon_Internal.make, {
                                      icon: Type_Common.audioVersionCodeToIcon(param.code, "LightGrey"),
                                      size: iconSize,
                                      title: label
                                    }), React.createElement(Atom_Text.ScreenreadersLabel.make, {
                                      children: label
                                    }));
                    })),
              display: display,
              kind: /* List */5
            })) : undefined;
  var content;
  if (title$1 !== undefined) {
    if (subtitle !== undefined) {
      var tmp = {
        title: title$1,
        style: titleStyle,
        identifier: Organism_Teaser_Css_Identifier.hoverTitle
      };
      if (titleId !== undefined) {
        tmp.id = Caml_option.valFromOption(titleId);
      }
      var tmp$1 = {
        identifier: Organism_Teaser_Css_Identifier.hoverSubtitle,
        subtitle: subtitle._0,
        style: subtitleStyle,
        kind: "p"
      };
      if (subtitleId !== undefined) {
        tmp$1.id = Caml_option.valFromOption(subtitleId);
      }
      content = React.createElement(Atom_Column.make, {
            children: null
          }, React.createElement(Organism_Teaser_Title.make, tmp), React.createElement(Organism_Teaser_Subtitle.make, tmp$1));
    } else {
      var tmp$2 = {
        title: title$1,
        style: titleStyle,
        identifier: Organism_Teaser_Css_Identifier.hoverTitle
      };
      if (titleId !== undefined) {
        tmp$2.id = Caml_option.valFromOption(titleId);
      }
      content = React.createElement(Atom_Column.make, {
            children: React.createElement(Organism_Teaser_Title.make, tmp$2)
          });
    }
  } else if (subtitle !== undefined) {
    switch (subtitle.TAG | 0) {
      case /* SubtitleAsTitle */1 :
          var tmp$3 = {
            identifier: Organism_Teaser_Css_Identifier.hoverSubtitle,
            subtitle: subtitle._0,
            style: titleStyle,
            kind: "h3"
          };
          if (subtitleId !== undefined) {
            tmp$3.id = Caml_option.valFromOption(subtitleId);
          }
          content = React.createElement(Atom_Column.make, {
                children: React.createElement(Organism_Teaser_Subtitle.make, tmp$3)
              });
          break;
      case /* Normal */0 :
      case /* HoverOnly */2 :
          content = null;
          break;
      
    }
  } else {
    content = null;
  }
  var trailerButton;
  if (match.trailer !== undefined && programId !== undefined) {
    var trailerUrl = Curry._1(match$1.api.getTrailerUrl, programId);
    trailerButton = React.createElement(Atom_Cta.Link.make, {
          href: Curry._1(Type_String.Href.toString, trailerUrl),
          label: match$3.trailer_button,
          style: {
            TAG: /* Trailer */24,
            _0: /* Enabled */0,
            _1: /* Teaser */3
          },
          key: buttonTrailerKey
        });
  } else {
    trailerButton = null;
  }
  var genreLink = Belt_Option.map(match.genre, (function (param) {
          var url = param.url;
          var label = param.label;
          if (url !== undefined) {
            return React.createElement(Atom_Cta.Link.make, {
                        href: Curry._1(Type_String.Program.Genre.Url.toString, url),
                        label: Curry._1(Type_String.Program.Genre.Label.toString, label),
                        style: /* TeaserGenre */30
                      });
          }
          var style = Atom_Cta_Ds.make(/* TeaserGenre */30).textStyle;
          return React.createElement(Atom_Text.make, {
                      children: Curry._1(Type_String.Program.Genre.Label.toString, label),
                      style: style
                    });
        }));
  var param$1 = Atom_Image_Ds.make(pictureKind);
  var rulesWidth = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Screen_Css.toRules(undefined, undefined, Particle_Css.imageWidth, param$1.size));
  var rules = Particle_Screen_Ds.$$Array.concat(Particle_Screen_Ds.$$Array.concat(Particle_Screen_Ds.$$Array.concat(Organism_Teaser_Css.getPanelHoverWrapperRules(Caml_option.some(panelHoverWrapperMinHeight), pictureKind), Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, [hoverZIndex])), rulesWidth), match$6[0]);
  UseTrapFocus.make(hoverRef);
  var tmp$4;
  if (showTextPart) {
    var tmp$5;
    var exit = 0;
    if (audioVersions$1 !== undefined || genreLink !== undefined) {
      exit = 1;
    } else {
      tmp$5 = null;
    }
    if (exit === 1) {
      tmp$5 = React.createElement(Atom_Row.make, {
            blockSpace: genreAndAudioVersionsBlockSpace,
            children: null,
            innerSpace: genreAndAudioVersionsInnerSpace,
            wrap: /* OnOneLine */1
          }, Belt_Option.getWithDefault(genreLink, null), Belt_Option.getWithDefault(audioVersions$1, null));
    }
    var tmp$6 = {
      href: teaser.href,
      progression: progression,
      identifier: Organism_Teaser_Css_Identifier.hoverPlayButton,
      programKind: match.kind,
      status: programStatus,
      key: buttonPlayKey
    };
    if (screenReadersLabel !== undefined) {
      tmp$6.screenReadersLabel = Caml_option.valFromOption(screenReadersLabel);
    }
    tmp$4 = React.createElement(Atom_Column.make, {
          blockSpace: contentBlockSpace,
          children: null,
          displayOrder: textDisplayOrder,
          innerSpace: contentInnerSpace,
          width: Particle_Screen_Constants.oneHundredPctWidth
        }, content, description$1, tmp$5, React.createElement(Atom_Row.make, {
              children: React.createElement(Organism_Teaser_Hover_Play.make, tmp$6),
              innerSpace: innerSpaceRowButtons
            }), React.createElement(Atom_Row.make, {
              children: null,
              innerSpace: innerSpaceRowButtons
            }, trailerButton, React.createElement(Atom_FavoriteButton.make, {
                  teaser: teaser,
                  styleVariation: /* TeaserHover */4,
                  title: title$1,
                  availability: favoriteAvailability,
                  key: buttonFavoriteKey
                })));
  } else {
    tmp$4 = null;
  }
  var tmp$7 = {
    background: style.background,
    children: React.createElement(Atom_Column.make, {
          accessibility: documentAccessibility,
          alignItems: Particle_Screen_Constants.alignItemsFlexStart,
          children: null
        }, match$5[0], children, tmp$4),
    display: displayHover,
    identifier: Organism_Teaser_Css_Identifier.panelHoverWrapper,
    ref_: hoverRef,
    rules: rules
  };
  var tmp$8 = match$5[2];
  if (tmp$8 !== undefined) {
    tmp$7.kind = Caml_option.valFromOption(tmp$8);
  }
  return React.createElement(React.Fragment, undefined, match$5[3], React.createElement(Atom_Column.make, tmp$7));
}

var modalCloseButtonDisplayOrderValue = 1;

var portalHoverId = "teaser-hover-portal";

var make = Organism_Teaser_Hover;

export {
  modalCloseButtonDisplayOrderValue ,
  modalCloseButtonDisplayOrder ,
  textDisplayOrder ,
  modalCloseButtonBlockSpace ,
  contentBlockSpace ,
  contentInnerSpace ,
  genreAndAudioVersionsInnerSpace ,
  genreAndAudioVersionsBlockSpace ,
  innerSpaceRowButtons ,
  portalHoverId ,
  buttonFavoriteKey ,
  buttonPlayKey ,
  buttonTrailerKey ,
  displayHover ,
  getPictureKind ,
  AudioVersions ,
  documentAccessibility ,
  hoverZIndex ,
  Overlay ,
  make ,
}
/* modalCloseButtonDisplayOrder Not a pure module */
